import { deviceType } from "@tm/static/utils";
import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";
import { CommonModalDwebStyle } from "../CommonModalDweb/CommonModalDweb.style";
import { SpanTagStyle } from "../TextStyles/TextStyles.style";
import { ToastStyle } from "../Toast/Toast.style";

export interface TravellingToStyleProps {
  width?: string;
  travelCount?: boolean;
  open?: boolean;
  selected?: boolean;
  isDiabled?: boolean;
}

export interface CounterWrapProp {
  borderRadius?: string;
  height?: string;
  border?: string;
  width?: string;
  padding?: string;
  boxShadow?: string;
  gap?: string;
}

export interface IAgeRangeSectionWrap {
  isSelectOpen?: boolean;
  isBottomSheetFullScreen?: boolean;
}

export interface IAgeRangeSelect {
  left?: number;
  top?: number;
  bottom?: number;
}

export interface ITravellerAgeRangePickerWrap {
  isBottomSheetFullScreen?: boolean;
}

export interface IRangePickerContentWrap {
  isBottomSheetFullScreen?: boolean;
}

export const TravellingToWidgetStyle = styled.div`
  display: flex;
  margin-bottom: 24px;
  position: relative;
  @media ${deviceType.mobile} {
    flex-direction: column;
    ${CommonModalDwebStyle} {
      height: 300px;
    }
  }
  ${ToastStyle} {
    position: absolute;
    top: -20px;
    left: -20px;
    background: #005756;
    bottom: auto;
  }
`;

export const TravelPurposeWigetStyle = styled.div`
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e7e7e7;
  flex: 2;
  cursor: pointer;
  position: relative;
  border-left: none;
`;

export const TravellerCountWigetStyle = styled.div`
  background: #ffffff;
  border: 1px solid #e7e7e7;
  padding: 8px 16px;
  flex: 1.1;
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  @media ${deviceType.mobile} {
    border-radius: 0 0 8px 8px;
  }
`;

export const TravellerCountWigetShimmerStyle = styled(TravellerCountWigetStyle)`
  display: flex;
  gap: 20px;
  align-items: end;
`;

export const TravelDateWigetStyle = styled.div`
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e7e7e7;
  border-right: none;
  flex: 1;
  cursor: pointer;
  position: relative;
  @media ${deviceType.mobile} {
    border-right: 1px solid #e7e7e7;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
  }
`;

export const TravelDateWigetShimmerStyle = styled(TravelDateWigetStyle)`
  display: flex;
  gap: 20px;
  align-items: end;
`;

/* istanbul ignore next */
export const WidgetList = styled.div<TravellingToStyleProps>`
  background: #ffffff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  width: ${(p) => (p.width ? p.width : "111px")};
  height: 213px;
  overflow-y: scroll;
  position: absolute;
  top: 30px;
  right: 0;
  z-index: 1;
  ${(p) =>
    p.travelCount &&
    `
left:250px;
`}
`;

export const ListItem = styled.div<TravellingToStyleProps>`
  padding: 8px 16px;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
  display: flex;
  align-items: center;
  ${(p) =>
    p.selected &&
    `
    ${SpanTagStyle}{
        color:#008CFF;
        font-weight:700;
    }
    `}
  @media ${deviceType.mobile} {
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:last-child {
      margin-bottom: 60px;
    }
  }
`;

export const EmptySpace = styled.div`
  width: 100%;
  height: 60px;
  padding: 18px;
`;

export const ChevWrap = styled.div`
  margin-left: auto;
`;

export const DateSeparator = styled(SpanTagStyle)`
  flex-shrink: 0;
`;

export const ChevStateWrap = styled.div<TravellingToStyleProps>`
  cursor: pointer;
  transition: 0.5s ease-in;
  ${(p) =>
    p.open &&
    `
transform:rotate(180deg);
`}
`;

export const BtnWrap = styled.div`
  background: var(--base-white, #fff);
  box-shadow: 0px -1px 8px 0px rgba(0, 0, 0, 0.25);
  padding: 16px;
  position: fixed;
  bottom: 0;
  left: 0px;
  right: 0px;
`;

export const CounterWrap = styled.div<CounterWrapProp>`
  border-radius: ${(prop) => (prop.borderRadius ? prop.borderRadius : "4px")};
  background: #fff;
  box-shadow: ${(prop) =>
    prop.boxShadow ? prop.boxShadow : "0px 0px 6px 0px rgba(0, 0, 0, 0.2)"};
  padding: ${(prop) => (prop.padding ? prop.padding : "0px 8px")};
  display: flex;
  gap: ${(prop) => (prop.gap ? prop.gap : "14px")};
  ${(prop) => (prop.border ? `border:${prop.border}` : "")};
  align-items: center;
  width: fit-content;
  height: ${(prop) => (prop.height ? prop.height : "40px")};
  button {
    background: transparent;
    cursor: pointer;
    display: flex;
    padding: 0;
  }
  span {
    word-break: unset;
  }
`;

export const CounterBtn = styled.button<TravellingToStyleProps>`
  ${(p) =>
    p.isDiabled &&
    `
pointer-events:none;
opacity:0.5;
`}
`;

const mobileAnim = keyframes`
    0% {
        /* top: -100vh; */
        bottom: -100%;
        opacity: 0;
    }
    100% {
        bottom: 0;
        opacity: 1;
    }
`;

//here I am
export const TravellerAgeRangePickerWrap = styled.div<ITravellerAgeRangePickerWrap>`
  width: 393px;
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 1px 6px 0px #00000033;
  display: flex;
  flex-direction: column;
  z-index: 1;
  border-radius: 4px;
  position: absolute;
  @media ${deviceType.desktop} {
    right: 24px;
    top: 6px;
  }
  @media ${deviceType.mobile} {
    width: 100%;
    position: fixed;
    left: 0;
    flex-direction: column;
    ${(p) => p.isBottomSheetFullScreen && `height: 100vh;`}
    border-radius: 16px 16px 0 0;
    box-sizing: border-box;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: -100%;
    z-index: 10;
    background-color: #fff;
    animation-fill-mode: forwards;
    animation: ${mobileAnim} 0.3s ease-in-out;
    animation-fill-mode: forwards;
  }
`;

export const TravellerAgeRangeSelectSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media ${deviceType.mobile} {
    grid-template-columns: 1fr;
  }
  gap: 8px;
`;

export const AgeRangeSelectSection = styled.div`
  display: flex;
  padding: 8px 7px;
  background: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  gap: 14px;
  z-index: 3;
  align-items: center;
  width: 99px;
  height: 32px;
  @media ${deviceType.mobile} {
    position: relative;
  }
`;

export const CountSectionWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media ${deviceType.mobile} {
    z-index: -1;
    position: relative;
  }
  padding-bottom: 16px;
`;

export const AgeRangeSectionWrap = styled.div<IAgeRangeSectionWrap>`
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  gap: 16px;
  @media ${deviceType.desktop} {
    max-height: 220px;
    visibility: visible;
    position: relative;
    overflow-y: auto;
  }
  @media ${deviceType.mobile} {
    z-index: -1;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    ${(p) =>
      p.isBottomSheetFullScreen
        ? `flex-grow: 1;
    margin-bottom: 145px;
    `
        : ` max-height: 300px;`}
  }
`;

export const ApplyCtaSectionWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding 19px;
  box-shadow: 0px 1px 6px 0px #00000033;
  @media ${deviceType.mobile} {
    z-index: 1000;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
  }
`;

export const AgeRangeSelectMobileWrap = styled.div<IAgeRangeSelect>`
  display: flex;
  flex-direction: column;
  max-height: 143px;
  position: fixed;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  left: ${(p) => p.left && p.left}px;
  bottom: ${(p) => p.bottom && p.bottom}px;
`;

export const AgeRangeSelect = styled.div<IAgeRangeSelect>`
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  @media ${deviceType.desktop} {
    z-index: 100;
    position: fixed;
    ${(p) => p.top && `top:${p.top}px`};
    ${(p) => p.left && `left:${p.left}px`};
  }
  @media ${deviceType.mobile} {
    box-shadow: 0px 1px 7px 0px #00000033;
  }
  overflow-y: scroll;
  max-height: 134px;
`;

export const AgeSelectItem = styled.div`
  padding: 1px 25.4px;
  width: 100%;
  position: relative;
  background: #fff;
  cursor: pointer;
  &:hover {
    background: #eaf5ff;
    span {
      color: #008cff;
    }
  }
`;

export const RangePickerContentWrap = styled.div<IRangePickerContentWrap>`
  padding: 22px;
  @media ${deviceType.mobile} {
    z-index: -1;
    position: relative;
    margin-bottom: 70px;
    ${(p) =>
      p.isBottomSheetFullScreen &&
      `display: flex;
    flex-direction: column;
    height: 100vh;`}
  }
`;

export const UpsideDownTriangle = styled.div`
  width: 0;
  height: 0;
  border-left: 6.1px solid transparent;
  border-right: 6.1px solid transparent;
  border-top: 9px solid #fff;
  filter: drop-shadow(0px 1px 7px #00000033);
`;

export const TravellerAgenCountHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 24px 0px 0px 0px;
  padding: 11px 16px;
  border-bottom: 1px solid #d8d8d8;
`;

export const TravellerCounterComboBox = styled.div`
  background: #ffffff;
  border: 1px solid #e7e7e7;
  padding: 8px 16px;
  position: relative;
  cursor: pointer;
  @media ${deviceType.mobile} {
    border-radius: 0 0 8px 8px;
  }
`;

export const TravellerBookingForComboBox = styled.div`
  background: #ffffff;
  border: 1px solid #e7e7e7;
  padding: 8px 16px;
  position: relative;
  width: 29%;
  @media ${deviceType.mobile} {
    margin-top: 8px;
    border-radius: 8px;
    width: 100%;
  }
`;

export const TravellerText = styled.span`
  font-family: Lato;
  font-weight: 400;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-left: 4px;
`;

export const BookingForName = styled.span`
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 900;
`;

export const BookingForMail = styled.span`
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: ${theme.greyText6};
`;

export const TravellerCounterDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
`;

export const TravellerCounterDropdownItem = styled.div<{ selected?: boolean }>`
  padding: 8px 16px;
  cursor: pointer;
  background: ${({ selected }) => (selected ? "#f5f5f5" : "#fff")};
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  &:hover {
    background: #f0f0f0;
  }
`;

export const TravellerCountInputWrap = styled.div<{ isFocused?: boolean }>`
  background: ${(p) => (p.isFocused ? theme.lightBlueBg : theme.whiteText)};
  border: 1px solid ${theme.darkGreyBg};
  padding: 8px 20px;
  flex: 1.1;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 0 6px 6px 0;
  @media ${deviceType.mobile} {
    border-radius: 0 0 8px 8px;
  }
`;

export const TravellerCountErrorWrap = styled.div`
  position: absolute;
  bottom: -20px;
  right: 0;
`;

export const TravellerCountInputField = styled.input`
  border: none;
  outline: none;
  font-family: "Lato", sans-serif;
  font-weight: ${fontWeight.black};
  font-size: ${fontSize.font16};
  line-height: 100%;
  color: ${theme.blackText};
  padding: 0;
  width: 100%;
  background: transparent;
  &::placeholder {
    color: ${theme.greyText6};
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;
